module.exports = __webpack_public_path__ + "img/apple.c0cc9a05.svg";